<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：供货商-编辑
    -->
    <div v-loading="loading" class="goods-add pb50">
        <!--编辑供货商-->
        <el-form ref="form" size="small" :model="form" :rules="rules" label-width="100px">
            <div class="common-form">编辑供货商</div>
            <el-form-item label="供货商名称" prop="supplier_name"><el-input v-model="form.supplier_name" placeholder="请输入供货商名称" class="max-w460"></el-input></el-form-item>
            <el-form-item label="联系人" prop="link_user"><el-input v-model="form.link_user" placeholder="请输入联系人" class="max-w460"></el-input></el-form-item>
            <el-form-item label="联系电话" prop="tel"><el-input v-model="form.tel" placeholder="请输入联系电话" class="max-w460"></el-input></el-form-item>
            <el-form-item label="供货商状态">
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

            <!--提交-->
            <div class="common-button-wrapper">
                <el-button size="small" type="info" :loading="loading" @click="cancelFunc">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import SupplierApi from "@/api/supplier.js";

    export default {
        components: {
        },
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                form: {
                    supplier_id: "",
                    supplier_name: "",
                    link_user: "",
                    tel: "",
                    status: "0"
                },
                /*验证规则*/
                rules: {
                    supplier_name: [{ required: true, message: "请输入供货商名称", trigger: "blur" }],
                    link_user: [{ required: true, message: "请输入联系人", trigger: "blur" }],
                    tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
                }
            };
        },
        created() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                let self = this;
                // 取到路由带过来的参数
                const params = self.$route.query.supplier_id;
                SupplierApi.SupplierDetail({ supplier_id: params }, true)
                    .then((res) => {
                        self.form = res.data.detail;
                        self.tips_Id = res.data.detail.name;
                        if (!self.form.image) {
                            self.form.image = {};
                        }
                        self.category = res.data.catgory;
                        self.loading = false;
                    })
                    .catch((error) => {});
            },

            /*修改文章*/
            onSubmit() {
                let self = this;
                let params = this.form;
                // 取到路由带过来的参数
                SupplierApi.editSupplier(params, true)
                    .then((data) => {
                        self.$message({
                            message: data.msg,
                            type: "success"
                        });
                        self.$router.push("/supplier/supplier/index");
                    })
                    .catch((error) => {});
            },

            /*取消添加，返回文章列表*/
            cancelFunc() {
                this.$router.push({
                    path: "/supplier/supplier/index"
                });
            }
        }
    };
</script>

<style>
    .edit_container {
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/edit.vue